import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { RuleCommentHistoryItem } from '@/entities/expert-report';
import { HistoryEntryByline } from '@/shared/ui';
import { EvaluationCommentText } from './EvaluationCommentText';

type Props = {
  version: RuleCommentHistoryItem;
  expertReportId: number;
  /** Блок правила: ссылки в тексте версии открывают правило и знание этого блока */
  blockId: number;
};

/**
 * Версия комментария правила в его истории: кто её составил, когда и текст.
 *
 * Текст показывается так же, как в строке правила; замечание — одним своим текстом, так же, как правка.
 * У возврата к комментарию системы текста нет, поэтому на его месте названо само действие.
 */
export const EvaluationRuleCommentVersion: FC<Props> = ({ version, expertReportId, blockId }) => {
  const { t } = useTranslation(['dialogs']);
  const isReset = version.source === 'manual' && version.comment === null;

  return (
    <div className="flex flex-col gap-0.5">
      <HistoryEntryByline
        authorName={version.authorName}
        defaultAuthorName={t('dialogs:expertReport.versionBySystem')}
        date={version.createdAt}
      />
      {version.comment ? (
        <EvaluationCommentText comment={version.comment} expertReportId={expertReportId} blockId={blockId} />
      ) : (
        <span className="text-muted-foreground">
          {t(isReset ? 'dialogs:expertReport.commentVersionReset' : 'dialogs:expertReport.commentVersionEmpty')}
        </span>
      )}
    </div>
  );
};
